"use client"

import { useState } from "react"
import { X, Clock, Plus } from "lucide-react"
import Toast from "./Toast";

const AddMinutesModal = ({ isOpen, onClose, onSubmit }) => {
  const [minutes, setMinutes] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [toast, setToast] = useState(null);
  

  const showToast = (type, title, message = "", duration = 5000) => {
    setToast({ type, title, message, duration });
  };

  const closeToast = () => {
    setToast(null);
  };
  
  const handleInputChange = (e) => {
    const value = e.target.value
    // Only allow numbers and prevent negative values
    if (value === "" || (Number(value) >= 0 && !isNaN(value))) {
      setMinutes(value)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!minutes || Number(minutes) < 0) return;
  
    try {
      setIsLoading(true);
      setError(null);
  
      const params = new URLSearchParams({
        minutes_ago: minutes,
        env: process.env.REACT_APP_ENV_TYPE,
      });
  
      // Parallel fetch
      const [response, response2] = await Promise.all([
        fetch(`https://apis.metabuddy.app/flaskapp/store-triage-alerts?${params}`),
        fetch(`https://apis.metabuddy.app/flaskapp/get-cve-data?${params}`),
      ]);
  
      if (!response.ok || !response2.ok) {
        throw new Error(
          `One or both requests failed. Store status: ${response.status}, CVE status: ${response2.status}`
        );
      }
  
      const [data, data2] = await Promise.all([
        response.json(),
        response2.json(),
      ]);
  
      if (data.status === "success") {
        showToast("success", "Synced Successfully!", "Synced Successfully!");
        onSubmit();
        onClose();
      } else {
        throw new Error(`Sync failed: ${data.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error("Error during sync:", err);
      // setError(err.message); // if you want to show to user
      // showToast("error", "Sync Failed", err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setMinutes("")
    onClose()
  }


  if (!isOpen) return null


  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-t-3xl">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
              <Clock className="w-5 h-5 text-white" />
            </div>
            <h2 className="text-xl font-bold">Sync Alerts Data</h2>
          </div>
          <button onClick={handleClose} className="p-2 hover:bg-white/20 rounded-xl transition-colors duration-200">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-8">
          <div className="space-y-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Clock className="w-8 h-8 text-blue-600" />
              </div>
              <label className="block text-lg font-bold text-gray-800 mb-2">Enter minutes ago</label>
              <div className="relative">
                <input
                  type="number"
                  value={minutes}
                  onChange={handleInputChange}
                  min="0"
                  step="1"
                  placeholder="0"
                  className="w-full px-6 py-4 border-2 border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-2xl text-center font-bold text-gray-800"
                  required
                />
                
              </div>
              <p className="text-sm text-gray-500 mt-3"></p>
            </div>
          </div>

          {/* Footer */}
          <div className="flex gap-4 mt-8">
            <button
              type="button"
              onClick={handleClose}
              className="flex-1 px-6 py-4 border-2 border-gray-300 text-gray-700 rounded-2xl hover:bg-gray-50 transition-colors duration-200 font-medium"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!minutes || Number(minutes) < 0 || isSubmitting}
              className="flex-1 px-6 py-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-2xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 font-medium"
            >
              {isLoading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Processing...
                </>
              ) : (
                <>
                  <Plus className="w-5 h-5" />
                  Submit
                </>
              )}
            </button>
          </div>
        </form>

        {toast && <Toast toast={toast} onClose={closeToast} />}
      </div>
    </div>
  )
}

export default AddMinutesModal
